import { createElement } from "react";
import { useSlateStatic } from "slate-react";
const DefaultElement = ({ attributes, children, element }) => {
  const editor = useSlateStatic();
  return createElement(editor.isInline(element) ? "span" : "div", attributes, children);
};
DefaultElement.displayName = "DefaultElement";
export {
  DefaultElement
};
//# sourceMappingURL=DefaultElement.js.map
